import { useQuery } from 'react-query'
import { serviceProviderById } from '../../../utils/badaAppointmentApi'

const useServiceProviderById = (storeId, subsystem, selectedServiceProviderId) =>
    useQuery(
      'useServiceProviderById',
      () => serviceProviderById(storeId, subsystem, selectedServiceProviderId),
      { enabled: !!storeId && !!selectedServiceProviderId }
    )

export default useServiceProviderById   